import React from 'react';
interface Props {
    memo?: string,
}

export default ((props) => {
    return (
        <>
            {props.memo ? props.memo : ''}
        </>
    );
}) as React.FC<Props>;
